export const ENUMS = {
    "AccountInfoHasCallRailEnum": {
        "Yes": {
            "key": "Yes",
            "label": "Yes",
            "value": 1
        },
        "No": {
            "key": "No",
            "label": "No",
            "value": 0
        }
    },
    "AccountInfoHasLeadPropellerEnum": {
        "Yes": {
            "key": "Yes",
            "label": "Yes",
            "value": 1
        },
        "No": {
            "key": "No",
            "label": "No",
            "value": 0
        }
    },
    "AccountInfoHowLongInBusinessEnum": {
        "JustStarted": {
            "key": "JustStarted",
            "label": "Just Started",
            "value": "Just Started"
        },
        "OneToTwoYears": {
            "key": "OneToTwoYears",
            "label": "One To Two Years",
            "value": "1-2 years"
        },
        "ThreeToFiveYears": {
            "key": "ThreeToFiveYears",
            "label": "Three To Five Years",
            "value": "3-5 years"
        },
        "SixToTenYears": {
            "key": "SixToTenYears",
            "label": "Six To Ten Years",
            "value": "6-10 years"
        },
        "MoreThenTenYears": {
            "key": "MoreThenTenYears",
            "label": "More Then Ten Years",
            "value": "11+"
        }
    },
    "AccountInfoHowManyDealsEnum": {
        "Zero": {
            "key": "Zero",
            "label": "Zero",
            "value": "0"
        },
        "BetweenOneAndFive": {
            "key": "BetweenOneAndFive",
            "label": "Between One And Five",
            "value": "1-5"
        },
        "BetweenSixAndTwenty": {
            "key": "BetweenSixAndTwenty",
            "label": "Between Six And Twenty",
            "value": "6-20"
        },
        "MoreThenTwenty": {
            "key": "MoreThenTwenty",
            "label": "More Then Twenty",
            "value": "20+"
        }
    },
    "AccountInfoTypicalExitStrategyEnum": {
        "FixAndFlip": {
            "key": "FixAndFlip",
            "label": "Fix And Flip",
            "value": "Fix and Flip"
        },
        "Wholesale": {
            "key": "Wholesale",
            "label": "Wholesale",
            "value": "Wholesale"
        },
        "Rental": {
            "key": "Rental",
            "label": "Rental",
            "value": "Rental"
        },
        "SubjectTo": {
            "key": "SubjectTo",
            "label": "Subject To",
            "value": "Subject To"
        },
        "LeaseOption": {
            "key": "LeaseOption",
            "label": "Lease Option",
            "value": "Lease Option"
        },
        "OwnerFinance": {
            "key": "OwnerFinance",
            "label": "Owner Finance",
            "value": "Owner Finance"
        }
    },
    "AccountInfoUsedAutomatedFollowUpEnum": {
        "Yes": {
            "key": "Yes",
            "label": "Yes",
            "value": 1
        },
        "No": {
            "key": "No",
            "label": "No",
            "value": 0
        }
    },
    "AccountStatusEnum": {
        "Undefined": {
            "key": "Undefined",
            "label": "Undefined",
            "value": null
        },
        "Active": {
            "key": "Active",
            "label": "Active",
            "value": 1
        },
        "GracePeriod": {
            "key": "GracePeriod",
            "label": "Grace Period",
            "value": 2
        },
        "Canceled": {
            "key": "Canceled",
            "label": "Canceled",
            "value": 3
        },
        "Paused": {
            "key": "Paused",
            "label": "Paused",
            "value": 4
        },
        "Provisioning": {
            "key": "Provisioning",
            "label": "Provisioning",
            "value": 5
        }
    },
    "AccountTypeEnum": {
        "Customer": {
            "key": "Customer",
            "label": "Customer",
            "value": 0
        },
        "Employee": {
            "key": "Employee",
            "label": "Employee",
            "value": 1
        },
        "VIP": {
            "key": "VIP",
            "label": "VIP",
            "value": 2
        }
    },
    "ActivityActionEnum": {
        "Initial": {
            "key": "Initial",
            "label": "Initial",
            "value": 1
        },
        "Changed": {
            "key": "Changed",
            "label": "Changed",
            "value": 2
        },
        "Completed": {
            "key": "Completed",
            "label": "Completed",
            "value": 3
        },
        "Added": {
            "key": "Added",
            "label": "Added",
            "value": 4
        },
        "Deleted": {
            "key": "Deleted",
            "label": "Deleted",
            "value": 5
        },
        "UnCompleted": {
            "key": "UnCompleted",
            "label": "Un Completed",
            "value": 6
        },
        "Canceled": {
            "key": "Canceled",
            "label": "Canceled",
            "value": 7
        },
        "Resumed": {
            "key": "Resumed",
            "label": "Resumed",
            "value": 8
        }
    },
    "ActivityTypeEnum": {
        "Status": {
            "key": "Status",
            "label": "Status",
            "value": 1
        },
        "Checklist": {
            "key": "Checklist",
            "label": "Checklist",
            "value": 2
        },
        "ScheduledContact": {
            "key": "ScheduledContact",
            "label": "Scheduled Contact",
            "value": 3
        },
        "BuyingOffer": {
            "key": "BuyingOffer",
            "label": "Buying Offer",
            "value": 4
        },
        "Campaign": {
            "key": "Campaign",
            "label": "Campaign",
            "value": 5
        },
        "ExitStrategy": {
            "key": "ExitStrategy",
            "label": "Exit Strategy",
            "value": 6
        },
        "Motivation": {
            "key": "Motivation",
            "label": "Motivation",
            "value": 7
        },
        "Temperature": {
            "key": "Temperature",
            "label": "Temperature",
            "value": 8
        },
        "User": {
            "key": "User",
            "label": "User",
            "value": 9
        },
        "Appointment": {
            "key": "Appointment",
            "label": "Appointment",
            "value": 10
        },
        "Task": {
            "key": "Task",
            "label": "Task",
            "value": 11
        },
        "FollowUpSequence": {
            "key": "FollowUpSequence",
            "label": "FollowUpSequence",
            "value": 12
        }
    },
    "AnsweringSequenceStepTypeEnum": {
        "Greeting": {
            "key": "Greeting",
            "label": "Greeting",
            "value": 1
        },
        "Dial": {
            "key": "Dial",
            "label": "Dial",
            "value": 2
        },
        "SimultaneousRing": {
            "key": "SimultaneousRing",
            "label": "SimultaneousRing",
            "value": 3
        },
        "Voicemail": {
            "key": "Voicemail",
            "label": "Voicemail",
            "value": 4
        }
    },
    "AppointmentCancellationTypeEnum": {
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": 1
        },
        "User": {
            "key": "User",
            "label": "User",
            "value": 2
        },
        "Unknown": {
            "key": "Unknown",
            "label": "Unknown",
            "value": 3
        }
    },
    "AppointmentReminderTypeEnum": {
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 1
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 2
        }
    },
    "AutomationHookEnum": {
        "EnterStatus": {
            "key": "EnterStatus",
            "label": "Enter Status",
            "value": 1
        },
        "ExitStatus": {
            "key": "ExitStatus",
            "label": "Exit Status",
            "value": 2
        },
        "AfterAllRequiredTasksCompleted": {
            "key": "AfterAllRequiredTasksCompleted",
            "label": "After All Required Tasks Completed",
            "value": 4
        },
        "XTimeBeforeStatusDue": {
            "key": "XTimeBeforeStatusDue",
            "label": "X Time Before Status Due",
            "value": 3
        },
        "XTimeAfterEntersStatus": {
            "key": "XTimeAfterEntersStatus",
            "label": "X Time After Enters Status",
            "value": 5
        }
    },
    "AutomationTypeEnum": {
        "SendWebhook": {
            "key": "SendWebhook",
            "label": "Send Webhook",
            "value": "App\\Models\\SendWebhookAutomation"
        },
        "NotifyUsers": {
            "key": "NotifyUsers",
            "label": "Notify Users",
            "value": "App\\Models\\NotifyUsersAutomation"
        },
        "ManageUsers": {
            "key": "ManageUsers",
            "label": "Manage Users",
            "value": "App\\Models\\ManageUsersAutomation"
        },
        "AddTask": {
            "key": "AddTask",
            "label": "Add Task",
            "value": "App\\Models\\AddTaskAutomation"
        },
        "UpdateTemperature": {
            "key": "UpdateTemperature",
            "label": "Update Temperature",
            "value": "App\\Models\\UpdateRecordTemperatureAutomation"
        },
        "EmailPrimaryContact": {
            "key": "EmailPrimaryContact",
            "label": "Email Primary Contact",
            "value": "App\\Models\\EmailAutomation"
        },
        "TextPrimaryContact": {
            "key": "TextPrimaryContact",
            "label": "Text Primary Contact",
            "value": "App\\Models\\TextAutomation"
        }
    },
    "BillingCycleEnum": {
        "Monthly": {
            "key": "Monthly",
            "label": "Monthly",
            "value": 1
        },
        "Annual": {
            "key": "Annual",
            "label": "Annual",
            "value": 2
        }
    },
    "BillingPlanEnum": {
        "Pro": {
            "key": "Pro",
            "label": "Pro",
            "value": 2
        },
        "VIP": {
            "key": "VIP",
            "label": "VIP",
            "value": 3
        },
        "Closed": {
            "key": "Closed",
            "label": "Closed",
            "value": 4
        },
        "Employee": {
            "key": "Employee",
            "label": "Employee",
            "value": 5
        },
        "Starter": {
            "key": "Starter",
            "label": "Starter",
            "value": 6
        },
        "Elite": {
            "key": "Elite",
            "label": "Elite",
            "value": 7
        }
    },
    "BillingSpecialEnum": {
        "WebinarSpecial": {
            "key": "WebinarSpecial",
            "label": "Webinar Special",
            "value": 1
        }
    },
    "BillingUsageTypeEnum": {
        "Plan": {
            "key": "Plan",
            "label": "Plan",
            "value": 1
        },
        "User": {
            "key": "User",
            "label": "User",
            "value": 2
        },
        "Phone": {
            "key": "Phone",
            "label": "Phone",
            "value": 3
        },
        "Minute": {
            "key": "Minute",
            "label": "Minute",
            "value": 4
        },
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 5
        }
    },
    "BuyingAnalysisTypeEnum": {
        "FixAndFlip": {
            "key": "FixAndFlip",
            "label": "Fix and Flip",
            "value": "App\\Models\\FixAndFlipAnalysis"
        },
        "Wholesale": {
            "key": "Wholesale",
            "label": "Wholesale",
            "value": "App\\Models\\WholesaleAnalysis"
        }
    },
    "BuyingInfoStatusEnum": {
        "AwaitingResponse": {
            "key": "AwaitingResponse",
            "label": "Awaiting Response",
            "value": 1
        },
        "Rejected": {
            "key": "Rejected",
            "label": "Rejected",
            "value": 2
        },
        "VerbalOfferAccepted": {
            "key": "VerbalOfferAccepted",
            "label": "Verbal Offer Accepted",
            "value": 3
        },
        "AwaitingSignature": {
            "key": "AwaitingSignature",
            "label": "Awaiting Signature",
            "value": 4
        },
        "UnderContract": {
            "key": "UnderContract",
            "label": "Under Contract",
            "value": 5
        },
        "StartMarketing": {
            "key": "StartMarketing",
            "label": "Start Marketing",
            "value": 6
        },
        "Purchased": {
            "key": "Purchased",
            "label": "Purchased",
            "value": 7
        },
        "LongTermFollowUp": {
            "key": "LongTermFollowUp",
            "label": "Long Term Follow Up",
            "value": 8
        }
    },
    "BuyingOfferMadeByEnum": {
        "Buyer": {
            "key": "Buyer",
            "label": "Buyer",
            "value": 1
        },
        "Seller": {
            "key": "Seller",
            "label": "Seller",
            "value": 2
        }
    },
    "BuyingOfferStatusEnum": {
        "Pending": {
            "key": "Pending",
            "label": "Pending",
            "value": 1
        },
        "Accepted": {
            "key": "Accepted",
            "label": "Accepted",
            "value": 2
        },
        "Rejected": {
            "key": "Rejected",
            "label": "Rejected",
            "value": 3
        }
    },
    "BuyingOfferTypeEnum": {
        "Verbal": {
            "key": "Verbal",
            "label": "Verbal",
            "value": 1
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 2
        },
        "Written": {
            "key": "Written",
            "label": "Written",
            "value": 4
        },
        "Unknown": {
            "key": "Unknown",
            "label": "Unknown",
            "value": 3
        }
    },
    "CalendarIntegrationTypeEnum": {
        "Google": {
            "key": "Google",
            "label": "Google",
            "value": 3
        }
    },
    "CallLogTypeEnum": {
        "Call": {
            "key": "Call",
            "label": "Call",
            "value": 1
        },
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 2
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 3
        }
    },
    "CallScriptStatusEnum": {
        "Active": {
            "key": "Active",
            "label": "Active",
            "value": 1
        },
        "Inactive": {
            "key": "Inactive",
            "label": "Inactive",
            "value": 0
        }
    },
    "CallScriptStepFieldTypeEnum": {
        "Record": {
            "key": "Record",
            "label": "Record",
            "value": "App\\Models\\Record"
        },
        "Note": {
            "key": "Note",
            "label": "Note",
            "value": "App\\Models\\Note"
        },
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": "App\\Models\\Contact"
        },
        "Property": {
            "key": "Property",
            "label": "Property",
            "value": "App\\Models\\Property"
        },
        "CustomField": {
            "key": "CustomField",
            "label": "CustomField",
            "value": "App\\Models\\CustomField"
        }
    },
    "CallScriptTypeEnum": {
        "Lead": {
            "key": "Lead",
            "label": "Lead",
            "value": 1
        },
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": 2
        }
    },
    "CallrailNumberVerificationStatusEnum": {
        "Unknown": {
            "key": "Unknown",
            "label": "Unknown",
            "value": 1
        },
        "Verified": {
            "key": "Verified",
            "label": "Verified",
            "value": 2
        },
        "FailedVerification": {
            "key": "FailedVerification",
            "label": "Failed Verification",
            "value": 3
        }
    },
    "CampaignChannelEnum": {
        "BanditSigns": {
            "key": "BanditSigns",
            "label": "Bandit Signs",
            "value": 8
        },
        "Billboards": {
            "key": "Billboards",
            "label": "Billboards",
            "value": 7
        },
        "Classifieds": {
            "key": "Classifieds",
            "label": "Classifieds",
            "value": 11
        },
        "ColdCalling": {
            "key": "ColdCalling",
            "label": "Cold Calling",
            "value": 10
        },
        "DirectMail": {
            "key": "DirectMail",
            "label": "Direct Mail",
            "value": 4
        },
        "DoorKnocking": {
            "key": "DoorKnocking",
            "label": "Door Knocking",
            "value": 9
        },
        "FacebookAds": {
            "key": "FacebookAds",
            "label": "Facebook Ads",
            "value": 2
        },
        "GoogleAds": {
            "key": "GoogleAds",
            "label": "Google Ads",
            "value": 1
        },
        "MLS": {
            "key": "MLS",
            "label": "MLS",
            "value": 14
        },
        "Organic": {
            "key": "Organic",
            "label": "Organic",
            "value": 12
        },
        "Radio": {
            "key": "Radio",
            "label": "Radio",
            "value": 6
        },
        "Referrals": {
            "key": "Referrals",
            "label": "Referrals",
            "value": 13
        },
        "RinglessVoicemail": {
            "key": "RinglessVoicemail",
            "label": "Ringless Voicemail",
            "value": 16
        },
        "Texting": {
            "key": "Texting",
            "label": "Texting",
            "value": 15
        },
        "TV": {
            "key": "TV",
            "label": "TV",
            "value": 5
        },
        "Website": {
            "key": "Website",
            "label": "Website",
            "value": 3
        },
        "Other": {
            "key": "Other",
            "label": "Other",
            "value": 17
        }
    },
    "CampaignInboundChannelEnum": {
        "BanditSigns": {
            "key": "BanditSigns",
            "label": "Bandit Signs",
            "value": 8
        },
        "Billboards": {
            "key": "Billboards",
            "label": "Billboards",
            "value": 7
        },
        "Classifieds": {
            "key": "Classifieds",
            "label": "Classifieds",
            "value": 11
        },
        "Facebook": {
            "key": "Facebook",
            "label": "Facebook",
            "value": 2
        },
        "Google": {
            "key": "Google",
            "label": "Google",
            "value": 1
        },
        "Organic": {
            "key": "Organic",
            "label": "Organic",
            "value": 12
        },
        "Radio": {
            "key": "Radio",
            "label": "Radio",
            "value": 6
        },
        "Referrals": {
            "key": "Referrals",
            "label": "Referrals",
            "value": 13
        },
        "TV": {
            "key": "TV",
            "label": "TV",
            "value": 5
        },
        "Other": {
            "key": "Other",
            "label": "Other",
            "value": 17
        }
    },
    "CampaignOutboundChannelEnum": {
        "ColdCalling": {
            "key": "ColdCalling",
            "label": "Cold Calling",
            "value": 10
        },
        "DoorKnocking": {
            "key": "DoorKnocking",
            "label": "Door Knocking",
            "value": 9
        },
        "DirectMail": {
            "key": "DirectMail",
            "label": "Direct Mail",
            "value": 4
        },
        "MLS": {
            "key": "MLS",
            "label": "MLS",
            "value": 14
        },
        "Texting": {
            "key": "Texting",
            "label": "Texting",
            "value": 15
        },
        "RinglessVoicemail": {
            "key": "RinglessVoicemail",
            "label": "Ringless Voicemail",
            "value": 16
        },
        "Other": {
            "key": "Other",
            "label": "Other",
            "value": 17
        }
    },
    "CancelAttemptABOptionsEnum": {
        "PauseFirst": {
            "key": "PauseFirst",
            "label": "Pause First",
            "value": 1
        },
        "OfferFirst": {
            "key": "OfferFirst",
            "label": "Offer First",
            "value": 2
        }
    },
    "CancelAttemptAcceptedOfferEnum": {
        "Discount": {
            "key": "Discount",
            "label": "Discount",
            "value": 1
        },
        "ExpertCall": {
            "key": "ExpertCall",
            "label": "ExpertCall",
            "value": 2
        },
        "WalkThruVideo": {
            "key": "WalkThruVideo",
            "label": "WalkThruVideo",
            "value": 3
        }
    },
    "CancelAttemptOutcomeEnum": {
        "Stopped": {
            "key": "Stopped",
            "label": "Stopped",
            "value": 1
        },
        "Paused": {
            "key": "Paused",
            "label": "Paused",
            "value": 2
        },
        "Discounted": {
            "key": "Discounted",
            "label": "Discounted",
            "value": 3
        },
        "Cancelled": {
            "key": "Cancelled",
            "label": "Cancelled",
            "value": 4
        }
    },
    "CancelAttemptReasonEnum": {
        "NonPayment": {
            "key": "NonPayment",
            "label": "NonPayment",
            "value": 1
        },
        "Switching": {
            "key": "Switching",
            "label": "Switching",
            "value": 2
        },
        "TooDifficult": {
            "key": "TooDifficult",
            "label": "TooDifficult",
            "value": 3
        },
        "TooExpensive": {
            "key": "TooExpensive",
            "label": "TooExpensive",
            "value": 4
        },
        "NotSatisfied": {
            "key": "NotSatisfied",
            "label": "NotSatisfied",
            "value": 5
        },
        "Other": {
            "key": "Other",
            "label": "Other",
            "value": 6
        }
    },
    "ClientStoreEnum": {
        "Account": {
            "key": "Account",
            "label": "Account",
            "value": "account"
        },
        "Market": {
            "key": "Market",
            "label": "Market",
            "value": "market"
        },
        "Record": {
            "key": "Record",
            "label": "Record",
            "value": "activeRecord"
        }
    },
    "CommunicationDeliveryStatusEnum": {
        "Pending": {
            "key": "Pending",
            "label": "Pending",
            "value": 0
        },
        "Delivered": {
            "key": "Delivered",
            "label": "Delivered",
            "value": 1
        },
        "Failed": {
            "key": "Failed",
            "label": "Failed",
            "value": 2
        }
    },
    "CommunicationDirectionEnum": {
        "Inbound": {
            "key": "Inbound",
            "label": "Inbound",
            "value": 1
        },
        "Outbound": {
            "key": "Outbound",
            "label": "Outbound",
            "value": 2
        }
    },
    "CommunicationTypeEnum": {
        "Call": {
            "key": "Call",
            "label": "Call",
            "value": 1
        },
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 2
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 3
        },
        "VideoCall": {
            "key": "VideoCall",
            "label": "VideoCall",
            "value": 4
        }
    },
    "ContactMassActionTypeEnum": {
        "Types": {
            "key": "Types",
            "label": "Types",
            "value": 1
        },
        "Tags": {
            "key": "Tags",
            "label": "Tags",
            "value": 2
        }
    },
    "ContactTypeEnum": {
        "Other": {
            "key": "Other",
            "label": "Other",
            "value": 0
        },
        "Seller": {
            "key": "Seller",
            "label": "Seller",
            "value": 1
        }
    },
    "CouponCodeEnum": {
        "OneYearFree": {
            "key": "OneYearFree",
            "label": "One Year Free",
            "value": "webinar-special-one-year"
        },
        "WEBINARSPECIAL2022": {
            "key": "WEBINARSPECIAL2022",
            "label": "WEBINAR SPECIAL 2022",
            "value": "webinar-special-2022"
        },
        "VIPACCOUNT": {
            "key": "VIPACCOUNT",
            "label": "VIP ACCOUNT",
            "value": "eiH5B8J9"
        }
    },
    "CouponDurationEnum": {
        "Forever": {
            "key": "Forever",
            "label": "Forever",
            "value": "forever"
        },
        "Once": {
            "key": "Once",
            "label": "Once",
            "value": "once"
        },
        "Repeating": {
            "key": "Repeating",
            "label": "Repeating",
            "value": "repeating"
        }
    },
    "CouponTypeEnum": {
        "Percentage": {
            "key": "Percentage",
            "label": "Percentage",
            "value": 1
        },
        "FixedAmount": {
            "key": "FixedAmount",
            "label": "Fixed Amount",
            "value": 2
        }
    },
    "CustomFieldTypeEnum": {
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 1
        },
        "Number": {
            "key": "Number",
            "label": "Number",
            "value": 2
        },
        "Date": {
            "key": "Date",
            "label": "Date",
            "value": 3
        },
        "Time": {
            "key": "Time",
            "label": "Time",
            "value": 4
        },
        "DropDown": {
            "key": "DropDown",
            "label": "Drop Down",
            "value": 5
        },
        "Url": {
            "key": "Url",
            "label": "Url",
            "value": 6
        },
        "TextArea": {
            "key": "TextArea",
            "label": "Text Area",
            "value": 7
        },
        "Phone": {
            "key": "Phone",
            "label": "Phone",
            "value": 8
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 9
        },
        "Currency": {
            "key": "Currency",
            "label": "Currency",
            "value": 10
        }
    },
    "CustomFieldableTypeEnum": {
        "Record": {
            "key": "Record",
            "label": "Record",
            "value": "App\\Models\\Record"
        },
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": "App\\Models\\Contact"
        },
        "Property": {
            "key": "Property",
            "label": "Property",
            "value": "App\\Models\\Property"
        },
        "ContactType": {
            "key": "ContactType",
            "label": "ContactType",
            "value": "App\\Models\\ContactType"
        }
    },
    "DealProbabilityScoreEnum": {
        "NoScore": {
            "key": "NoScore",
            "label": "No Score",
            "value": 0
        },
        "Score1": {
            "key": "Score1",
            "label": "Score 1",
            "value": 1
        },
        "Score2": {
            "key": "Score2",
            "label": "Score 2",
            "value": 2
        },
        "Score3": {
            "key": "Score3",
            "label": "Score 3",
            "value": 3
        },
        "Score4": {
            "key": "Score4",
            "label": "Score 4",
            "value": 4
        },
        "Score5": {
            "key": "Score5",
            "label": "Score 5",
            "value": 5
        },
        "Score6": {
            "key": "Score6",
            "label": "Score 6",
            "value": 6
        }
    },
    "DomainServiceProviderTypeEnum": {
        "GoDaddy": {
            "key": "GoDaddy",
            "label": "GoDaddy",
            "value": 1
        },
        "DreamHost": {
            "key": "DreamHost",
            "label": "DreamHost",
            "value": 2
        },
        "Bluehost": {
            "key": "Bluehost",
            "label": "Bluehost",
            "value": 3
        },
        "Wix": {
            "key": "Wix",
            "label": "Wix",
            "value": 4
        },
        "Namecheap": {
            "key": "Namecheap",
            "label": "Namecheap",
            "value": 5
        },
        "NameCom": {
            "key": "NameCom",
            "label": "Name.com",
            "value": 6
        },
        "Cloudflare": {
            "key": "Cloudflare",
            "label": "Cloudflare",
            "value": 7
        },
        "Siteground": {
            "key": "Siteground",
            "label": "Siteground",
            "value": 8
        }
    },
    "EmailIntegrationTypeEnum": {
        "Gmail": {
            "key": "Gmail",
            "label": "Gmail",
            "value": 1
        },
        "MailGun": {
            "key": "MailGun",
            "label": "Mail Gun",
            "value": 4
        }
    },
    "EventTypeEnum": {
        "ExportedLeads": {
            "key": "ExportedLeads",
            "label": "Exported Leads",
            "value": 1
        },
        "ExportedContacts": {
            "key": "ExportedContacts",
            "label": "Exported Contacts",
            "value": 2
        }
    },
    "ExitStrategyEnum": {
        "Unknown": {
            "key": "Unknown",
            "label": "Unknown",
            "value": 1
        },
        "AgentReferral": {
            "key": "AgentReferral",
            "label": "Agent Referral",
            "value": 4
        },
        "Development": {
            "key": "Development",
            "label": "Development",
            "value": 12
        },
        "FixAndFlip": {
            "key": "FixAndFlip",
            "label": "Fix and Flip",
            "value": 2
        },
        "LeaseOption": {
            "key": "LeaseOption",
            "label": "Lease Option",
            "value": 5
        },
        "OwnerFinance": {
            "key": "OwnerFinance",
            "label": "Owner Finance",
            "value": 6
        },
        "RentalAsIs": {
            "key": "RentalAsIs",
            "label": "Rental As Is",
            "value": 8
        },
        "RentalRehab": {
            "key": "RentalRehab",
            "label": "Rental Rehab",
            "value": 7
        },
        "RetailListing": {
            "key": "RetailListing",
            "label": "Retail Listing",
            "value": 9
        },
        "SubjectTo": {
            "key": "SubjectTo",
            "label": "Subject To",
            "value": 10
        },
        "Wholesale": {
            "key": "Wholesale",
            "label": "Wholesale",
            "value": 3
        },
        "Wholetail": {
            "key": "Wholetail",
            "label": "Wholetail",
            "value": 11
        }
    },
    "FcmActionEnum": {
        "NewLead": {
            "key": "NewLead",
            "label": "New Lead",
            "value": "newLead"
        },
        "Mention": {
            "key": "Mention",
            "label": "Mention",
            "value": "mention"
        },
        "AssignedLead": {
            "key": "AssignedLead",
            "label": "Assigned Lead",
            "value": "assignedLead"
        },
        "AssignedTask": {
            "key": "AssignedTask",
            "label": "Assigned Task",
            "value": "assignedTask"
        },
        "AssignedAppointment": {
            "key": "AssignedAppointment",
            "label": "Assigned Appointment",
            "value": "assignedAppointment"
        },
        "CallResponse": {
            "key": "CallResponse",
            "label": "Call Response",
            "value": "callResponse"
        },
        "TextResponse": {
            "key": "TextResponse",
            "label": "Text Response",
            "value": "textResponse"
        },
        "FollowUpResponse": {
            "key": "FollowUpResponse",
            "label": "Follow Up Response",
            "value": "followUpResponse"
        }
    },
    "FeatureEnum": {
        "StorageIntegration": {
            "key": "StorageIntegration",
            "label": "StorageIntegration",
            "value": "has_storage_integration_feature"
        },
        "EmailIntegration": {
            "key": "EmailIntegration",
            "label": "EmailIntegration",
            "value": "has_email_integration_feature"
        },
        "CalendarIntegration": {
            "key": "CalendarIntegration",
            "label": "CalendarIntegration",
            "value": "has_calendar_integration_feature"
        },
        "PhoneIntegration": {
            "key": "PhoneIntegration",
            "label": "PhoneIntegration",
            "value": "has_phone_integration_feature"
        },
        "FollowUpSequence": {
            "key": "FollowUpSequence",
            "label": "FollowUpSequence",
            "value": "has_follow_up_sequence_feature"
        },
        "Webhooks": {
            "key": "Webhooks",
            "label": "Webhooks",
            "value": "has_webhooks_feature"
        },
        "Imports": {
            "key": "Imports",
            "label": "Imports",
            "value": "has_imports_feature"
        },
        "Exports": {
            "key": "Exports",
            "label": "Exports",
            "value": "has_exports_feature"
        },
        "EmailNotifications": {
            "key": "EmailNotifications",
            "label": "EmailNotifications",
            "value": "has_email_notifications_feature"
        },
        "TextNotifications": {
            "key": "TextNotifications",
            "label": "TextNotifications",
            "value": "has_text_notifications_feature"
        },
        "InviteUsers": {
            "key": "InviteUsers",
            "label": "InviteUsers",
            "value": "has_invite_users_feature"
        },
        "Automation": {
            "key": "Automation",
            "label": "Automation",
            "value": "has_automation_feature"
        },
        "CreatesPublicAssets": {
            "key": "CreatesPublicAssets",
            "label": "CreatesPublicAssets",
            "value": "has_creates_public_assets_feature"
        },
        "AdvancedReporting": {
            "key": "AdvancedReporting",
            "label": "AdvancedReporting",
            "value": "has_advanced_reporting_feature"
        },
        "SmrtPhoneIntegration": {
            "key": "SmrtPhoneIntegration",
            "label": "SmrtPhoneIntegration",
            "value": "has_smrt_phone_integration_feature"
        },
        "MidTierPropertyData": {
            "key": "MidTierPropertyData",
            "label": "MidTierPropertyData",
            "value": "has_mid_tier_property_data_feature"
        },
        "AdvancedTierPropertyData": {
            "key": "AdvancedTierPropertyData",
            "label": "AdvancedTierPropertyData",
            "value": "has_advanced_tier_property_data_feature"
        },
        "Comp": {
            "key": "Comp",
            "label": "Comp",
            "value": "has_comp_feature"
        },
        "PhoneSupport": {
            "key": "PhoneSupport",
            "label": "PhoneSupport",
            "value": "has_phone_support_feature"
        }
    },
    "FixAndFlipSellingInfoStatusEnum": {
        "ReceivedOffer": {
            "key": "ReceivedOffer",
            "label": "Received Offer",
            "value": 1
        },
        "Negotiating": {
            "key": "Negotiating",
            "label": "Negotiating",
            "value": 2
        },
        "AcceptedOffer": {
            "key": "AcceptedOffer",
            "label": "Accepted Offer",
            "value": 3
        },
        "UnderContract": {
            "key": "UnderContract",
            "label": "Under Contract",
            "value": 4
        },
        "Sold": {
            "key": "Sold",
            "label": "Sold",
            "value": 5
        }
    },
    "FollowUpSequenceStatusEnum": {
        "Active": {
            "key": "Active",
            "label": "Active",
            "value": 1
        },
        "Complete": {
            "key": "Complete",
            "label": "Complete",
            "value": 2
        },
        "Paused": {
            "key": "Paused",
            "label": "Paused",
            "value": 3
        },
        "Canceled": {
            "key": "Canceled",
            "label": "Canceled",
            "value": 4
        }
    },
    "FollowUpSequenceStepTypeEnum": {
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 1
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 2
        },
        "Task": {
            "key": "Task",
            "label": "Task",
            "value": 3
        },
        "SendWebhook": {
            "key": "SendWebhook",
            "label": "Send Webhook",
            "value": 5
        }
    },
    "FollowUpSequenceTemplateEndStepOptionsEnum": {
        "MoveToManualFollowUp": {
            "key": "MoveToManualFollowUp",
            "label": "Move To Manual Follow Up",
            "value": 1
        },
        "StartNewSequence": {
            "key": "StartNewSequence",
            "label": "Start New Sequence",
            "value": 3
        },
        "ChangeStatus": {
            "key": "ChangeStatus",
            "label": "Change Status",
            "value": 4
        }
    },
    "FollowUpSequenceTemplateStatusEnum": {
        "Ready": {
            "key": "Ready",
            "label": "Ready",
            "value": 0
        },
        "Queued": {
            "key": "Queued",
            "label": "Queued",
            "value": 1
        },
        "Processing": {
            "key": "Processing",
            "label": "Processing",
            "value": 2
        }
    },
    "ForwarderTypeEnum": {
        "User": {
            "key": "User",
            "label": "User",
            "value": "App\\Models\\User"
        },
        "PhoneAgent": {
            "key": "PhoneAgent",
            "label": "Phone Agent",
            "value": "App\\Models\\PhoneAgent"
        }
    },
    "ImportStatusEnum": {
        "NoFileUploaded": {
            "key": "NoFileUploaded",
            "label": "No File Uploaded",
            "value": 1
        },
        "FileUploaded": {
            "key": "FileUploaded",
            "label": "File Uploaded",
            "value": 2
        },
        "Validating": {
            "key": "Validating",
            "label": "Validating",
            "value": 3
        },
        "Validated": {
            "key": "Validated",
            "label": "Validated",
            "value": 4
        },
        "FailedValidation": {
            "key": "FailedValidation",
            "label": "Failed Validation",
            "value": 10
        },
        "Importing": {
            "key": "Importing",
            "label": "Importing",
            "value": 5
        },
        "Imported": {
            "key": "Imported",
            "label": "Imported",
            "value": 6
        },
        "FailedImport": {
            "key": "FailedImport",
            "label": "Failed Import",
            "value": 9
        },
        "RollingBack": {
            "key": "RollingBack",
            "label": "Rolling Back",
            "value": 7
        },
        "RolledBack": {
            "key": "RolledBack",
            "label": "Rolled Back",
            "value": 8
        },
        "FailedRollBack": {
            "key": "FailedRollBack",
            "label": "Failed Roll Back",
            "value": 11
        }
    },
    "ImportTypeEnum": {
        "Record": {
            "key": "Record",
            "label": "Record",
            "value": 0
        },
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": 1
        }
    },
    "InboundCallCallerIdEnum": {
        "ContactNumber": {
            "key": "ContactNumber",
            "label": "Contact Number",
            "value": 0
        },
        "ForefrontNumber": {
            "key": "ForefrontNumber",
            "label": "Forefront Number",
            "value": 1
        }
    },
    "InboxTypeEnum": {
        "NewLead": {
            "key": "NewLead",
            "label": "NewLead",
            "value": 0
        },
        "InboundComm": {
            "key": "InboundComm",
            "label": "InboundComm",
            "value": 1
        }
    },
    "IntegrationTypeEnum": {
        "Gmail": {
            "key": "Gmail",
            "label": "Gmail",
            "value": 1
        },
        "MailGun": {
            "key": "MailGun",
            "label": "Mail Gun",
            "value": 4
        },
        "CallRail": {
            "key": "CallRail",
            "label": "CallRail",
            "value": 2
        },
        "Forefront": {
            "key": "Forefront",
            "label": "Forefront",
            "value": 5
        },
        "SmrtPhone": {
            "key": "SmrtPhone",
            "label": "SmrtPhone",
            "value": 7
        },
        "PartnerPortalCallRail": {
            "key": "PartnerPortalCallRail",
            "label": "Partner Portal CallRail",
            "value": 8
        },
        "GoogleCalendar": {
            "key": "GoogleCalendar",
            "label": "Google Calendar",
            "value": 3
        },
        "LaunchControl": {
            "key": "LaunchControl",
            "label": "Launch Control",
            "value": 6
        }
    },
    "MailGunEventEnum": {
        "Failed": {
            "key": "Failed",
            "label": "Failed",
            "value": 0
        },
        "Delivered": {
            "key": "Delivered",
            "label": "Delivered",
            "value": 1
        },
        "Opened": {
            "key": "Opened",
            "label": "Opened",
            "value": 2
        },
        "Clicked": {
            "key": "Clicked",
            "label": "Clicked",
            "value": 3
        },
        "Unsubscribed": {
            "key": "Unsubscribed",
            "label": "Unsubscribed",
            "value": 4
        },
        "Complained": {
            "key": "Complained",
            "label": "Complained",
            "value": 5
        }
    },
    "MaintenanceProcessStatusEnum": {
        "Pending": {
            "key": "Pending",
            "label": "Pending",
            "value": 1
        },
        "Running": {
            "key": "Running",
            "label": "Running",
            "value": 2
        },
        "Succeeded": {
            "key": "Succeeded",
            "label": "Succeeded",
            "value": 3
        },
        "Failed": {
            "key": "Failed",
            "label": "Failed",
            "value": 4
        },
        "Cancelled": {
            "key": "Cancelled",
            "label": "Cancelled",
            "value": 5
        }
    },
    "MotivationEnum": {
        "Unknown": {
            "key": "Unknown",
            "label": "Unknown",
            "value": 1
        },
        "BadRental": {
            "key": "BadRental",
            "label": "Bad Rental",
            "value": 2
        },
        "CuriousAboutValue": {
            "key": "CuriousAboutValue",
            "label": "Curious about Value",
            "value": 14
        },
        "Divorce": {
            "key": "Divorce",
            "label": "Divorce",
            "value": 11
        },
        "Downsizing": {
            "key": "Downsizing",
            "label": "Downsizing",
            "value": 3
        },
        "Foreclosure": {
            "key": "Foreclosure",
            "label": "Foreclosure",
            "value": 4
        },
        "HealthIssues": {
            "key": "HealthIssues",
            "label": "Health Issues",
            "value": 5
        },
        "Inherited": {
            "key": "Inherited",
            "label": "Inherited",
            "value": 6
        },
        "InvestorOrFlipper": {
            "key": "InvestorOrFlipper",
            "label": "Investor or Flipper",
            "value": 15
        },
        "ListedButNotSelling": {
            "key": "ListedButNotSelling",
            "label": "Listed but not Selling",
            "value": 7
        },
        "NeedToSellFast": {
            "key": "NeedToSellFast",
            "label": "Need to Sell Fast",
            "value": 8
        },
        "OutOfStateOwner": {
            "key": "OutOfStateOwner",
            "label": "Out of State Owner",
            "value": 19
        },
        "Relocating": {
            "key": "Relocating",
            "label": "Relocating",
            "value": 9
        },
        "SellerAgentOrRealtor": {
            "key": "SellerAgentOrRealtor",
            "label": "Seller Agent or Realtor",
            "value": 16
        },
        "TaxDelinquent": {
            "key": "TaxDelinquent",
            "label": "Tax Delinquent",
            "value": 13
        },
        "TiredLandlord": {
            "key": "TiredLandlord",
            "label": "Tired Landlord",
            "value": 12
        },
        "TooManyRepairs": {
            "key": "TooManyRepairs",
            "label": "Too Many Repairs",
            "value": 10
        },
        "Upsizing": {
            "key": "Upsizing",
            "label": "Upsizing",
            "value": 17
        },
        "Wholesaler": {
            "key": "Wholesaler",
            "label": "Wholesaler",
            "value": 18
        }
    },
    "NotificationCategoryEnum": {
        "Mentions": {
            "key": "Mentions",
            "label": "Mentions",
            "value": 1
        },
        "Tasks": {
            "key": "Tasks",
            "label": "Tasks",
            "value": 2
        },
        "Appointments": {
            "key": "Appointments",
            "label": "Appointments",
            "value": 3
        },
        "Leads": {
            "key": "Leads",
            "label": "Leads",
            "value": 4
        },
        "Comms": {
            "key": "Comms",
            "label": "Comms",
            "value": 5
        },
        "Profile": {
            "key": "Profile",
            "label": "Profile",
            "value": 6
        },
        "Errors": {
            "key": "Errors",
            "label": "Errors",
            "value": 7
        }
    },
    "NotificationSoundEnum": {
        "None": {
            "key": "None",
            "label": "None",
            "value": 0
        },
        "Short": {
            "key": "Short",
            "label": "Short",
            "value": 1
        },
        "Medium": {
            "key": "Medium",
            "label": "Medium",
            "value": 2
        },
        "Long": {
            "key": "Long",
            "label": "Long",
            "value": 3
        }
    },
    "OffsetDirectionEnum": {
        "Forward": {
            "key": "Forward",
            "label": "Forward",
            "value": 1
        },
        "Backward": {
            "key": "Backward",
            "label": "Backward",
            "value": 2
        }
    },
    "PartnerPortalIntegrationTypeEnum": {
        "CallRail": {
            "key": "CallRail",
            "label": "CallRail",
            "value": 1
        }
    },
    "PartnerStatusEnum": {
        "Inactive": {
            "key": "Inactive",
            "label": "Inactive",
            "value": 0
        },
        "Active": {
            "key": "Active",
            "label": "Active",
            "value": 1
        }
    },
    "PhoneIntegrationTypeEnum": {
        "PartnerCallRail": {
            "key": "PartnerCallRail",
            "label": "PartnerCallRail",
            "value": 8
        },
        "CallRail": {
            "key": "CallRail",
            "label": "CallRail",
            "value": 2
        },
        "Forefront": {
            "key": "Forefront",
            "label": "Forefront",
            "value": 5
        },
        "SmrtPhone": {
            "key": "SmrtPhone",
            "label": "SmrtPhone",
            "value": 7
        }
    },
    "PusherServiceEventTypeEnum": {
        "Updated": {
            "key": "Updated",
            "label": "Updated",
            "value": 1
        },
        "Created": {
            "key": "Created",
            "label": "Created",
            "value": 2
        },
        "Deleted": {
            "key": "Deleted",
            "label": "Deleted",
            "value": 3
        }
    },
    "PusherServiceMethodEnum": {
        "SetRoot": {
            "key": "SetRoot",
            "label": "SetRoot",
            "value": "setRoot"
        },
        "PatchRoot": {
            "key": "PatchRoot",
            "label": "PatchRoot",
            "value": "updateRoot"
        },
        "UpdateInCollection": {
            "key": "UpdateInCollection",
            "label": "UpdateInCollection",
            "value": "updateInCollection"
        },
        "AddToCollection": {
            "key": "AddToCollection",
            "label": "AddToCollection",
            "value": "addToCollection"
        },
        "RemoveFromCollection": {
            "key": "RemoveFromCollection",
            "label": "RemoveFromCollection",
            "value": "removeFromCollection"
        },
        "UpsertCollection": {
            "key": "UpsertCollection",
            "label": "UpsertCollection",
            "value": "upsertCollection"
        },
        "CreatedMarketEvent": {
            "key": "CreatedMarketEvent",
            "label": "CreatedMarketEvent",
            "value": "createdMarketEvent"
        },
        "UpdatedMarketEvent": {
            "key": "UpdatedMarketEvent",
            "label": "UpdatedMarketEvent",
            "value": "updatedMarketEvent"
        },
        "DeletedMarketEvent": {
            "key": "DeletedMarketEvent",
            "label": "DeletedMarketEvent",
            "value": "deletedMarketEvent"
        },
        "CreatedAccountEvent": {
            "key": "CreatedAccountEvent",
            "label": "CreatedAccountEvent",
            "value": "createdAccountEvent"
        },
        "UpdatedAccountEvent": {
            "key": "UpdatedAccountEvent",
            "label": "UpdatedAccountEvent",
            "value": "updatedAccountEvent"
        },
        "DeletedAccountEvent": {
            "key": "DeletedAccountEvent",
            "label": "DeletedAccountEvent",
            "value": "deletedAccountEvent"
        }
    },
    "QueueEnum": {
        "Default": {
            "key": "Default",
            "label": "Default",
            "value": "{default}"
        },
        "Import": {
            "key": "Import",
            "label": "Import",
            "value": "{import}"
        },
        "MaintenanceProcess": {
            "key": "MaintenanceProcess",
            "label": "Maintenance Process",
            "value": "{maintenanceProcess}"
        },
        "AccountCleanUp": {
            "key": "AccountCleanUp",
            "label": "Account Clean Up",
            "value": "{account-clean-up}"
        },
        "QueueableItems": {
            "key": "QueueableItems",
            "label": "Queueable Items",
            "value": "{queueableItems}"
        },
        "PusherEvents": {
            "key": "PusherEvents",
            "label": "Pusher Events",
            "value": "{pusherEvents}"
        },
        "PendingFollowUpSequenceSteps": {
            "key": "PendingFollowUpSequenceSteps",
            "label": "Pending Follow Up Sequence Steps",
            "value": "{pendingFollowUpSequenceSteps}"
        },
        "DefaultOld": {
            "key": "DefaultOld",
            "label": "Default Old",
            "value": "default"
        },
        "ImportOld": {
            "key": "ImportOld",
            "label": "Import Old",
            "value": "import"
        },
        "MaintenanceProcessOld": {
            "key": "MaintenanceProcessOld",
            "label": "Maintenance Process Old",
            "value": "maintenanceProcess"
        },
        "AccountCleanUpOld": {
            "key": "AccountCleanUpOld",
            "label": "Account Clean Up Old",
            "value": "account-clean-up"
        },
        "QueueableItemsOld": {
            "key": "QueueableItemsOld",
            "label": "Queueable Items Old",
            "value": "queueableItems"
        },
        "PusherEventsOld": {
            "key": "PusherEventsOld",
            "label": "Pusher Events Old",
            "value": "pusherEvents"
        },
        "PendingFollowUpSequenceStepsOld": {
            "key": "PendingFollowUpSequenceStepsOld",
            "label": "Pending Follow Up Sequence Steps Old",
            "value": "pendingFollowUpSequenceSteps"
        }
    },
    "QueueableStatusEnum": {
        "Pending": {
            "key": "Pending",
            "label": "Pending",
            "value": 0
        },
        "Queued": {
            "key": "Queued",
            "label": "Queued",
            "value": 1
        },
        "Processing": {
            "key": "Processing",
            "label": "Processing",
            "value": 2
        },
        "Errored": {
            "key": "Errored",
            "label": "Errored",
            "value": 3
        },
        "Completed": {
            "key": "Completed",
            "label": "Completed",
            "value": 4
        }
    },
    "RecordArchiveTypeEnum": {
        "Sold": {
            "key": "Sold",
            "label": "Sold",
            "value": 1
        },
        "Dead": {
            "key": "Dead",
            "label": "Dead",
            "value": 2
        },
        "NotALead": {
            "key": "NotALead",
            "label": "Not a Lead",
            "value": 3
        },
        "Rented": {
            "key": "Rented",
            "label": "Rented",
            "value": 4
        }
    },
    "RecordMassActionTypeEnum": {
        "Status": {
            "key": "Status",
            "label": "Status",
            "value": 1
        },
        "Campaign": {
            "key": "Campaign",
            "label": "Campaign",
            "value": 2
        },
        "Temperature": {
            "key": "Temperature",
            "label": "Temperature",
            "value": 3
        },
        "ExitStrategy": {
            "key": "ExitStrategy",
            "label": "Exit Strategy",
            "value": 4
        }
    },
    "RecordRoleEnum": {
        "None": {
            "key": "None",
            "label": "None",
            "value": 0
        },
        "Seller": {
            "key": "Seller",
            "label": "Seller",
            "value": 1
        },
        "Buyer": {
            "key": "Buyer",
            "label": "Buyer",
            "value": 2
        }
    },
    "RecordStateEnum": {
        "Prospecting": {
            "key": "Prospecting",
            "label": "Prospecting",
            "value": 0
        },
        "Active": {
            "key": "Active",
            "label": "Active",
            "value": 1
        },
        "FollowingUp": {
            "key": "FollowingUp",
            "label": "Following Up",
            "value": 2
        },
        "Archived": {
            "key": "Archived",
            "label": "Archived",
            "value": 3
        }
    },
    "RecordingTypeEnum": {
        "Greeting": {
            "key": "Greeting",
            "label": "Greeting",
            "value": 1
        },
        "Voicemail": {
            "key": "Voicemail",
            "label": "Voicemail",
            "value": 2
        }
    },
    "RetentionFlagTypeEnum": {
        "NoLeadsCreatedInLast30Days": {
            "key": "NoLeadsCreatedInLast30Days",
            "label": "No Leads Created In Last 30 Days",
            "value": 1
        },
        "AccountsWithZeroLoginsFor7Days": {
            "key": "AccountsWithZeroLoginsFor7Days",
            "label": "Accounts with Zero Logins for 7 days",
            "value": 2
        },
        "AccountsWithNoPhoneNumbersIntegratedForMoreThen7DaysAfterCreatingAccount": {
            "key": "AccountsWithNoPhoneNumbersIntegratedForMoreThen7DaysAfterCreatingAccount",
            "label": "Accounts with no Phone numbers integrated for more then 7 days after creating account",
            "value": 3
        },
        "AccountWithNoNewInboundPhoneCallsForMoreThen7Days": {
            "key": "AccountWithNoNewInboundPhoneCallsForMoreThen7Days",
            "label": "Account with no new inbound phone calls for more then 7 days",
            "value": 4
        },
        "AccountsThatDontCompleteAMinimumOf50PercentOfTheOnboardingProcessWithinTheFirst14Days": {
            "key": "AccountsThatDontCompleteAMinimumOf50PercentOfTheOnboardingProcessWithinTheFirst14Days",
            "label": "Accounts that dont complete a minimum of 50 percent of the onboarding process within the first 14 days",
            "value": 5
        },
        "AccountsWithNoNewLeadsInActiveFollowUpSequenceLast30Days": {
            "key": "AccountsWithNoNewLeadsInActiveFollowUpSequenceLast30Days",
            "label": "Accounts with no new leads in active follow up sequence last 30 days",
            "value": 6
        },
        "AccountsWithNoNewEmailIntegrationSetupAfterBeingActiveForMoreThen14Days": {
            "key": "AccountsWithNoNewEmailIntegrationSetupAfterBeingActiveForMoreThen14Days",
            "label": "Accounts with no new email integration setup after being active for more then 14 days",
            "value": 7
        },
        "AccountsWithZeroCommunicationLogsForMoreThen7Days": {
            "key": "AccountsWithZeroCommunicationLogsForMoreThen7Days",
            "label": "Accounts with zero communication logs for more then 7 days",
            "value": 8
        },
        "AccountsThatHaveMoreThen2ExportsWithinTheSameDay": {
            "key": "AccountsThatHaveMoreThen2ExportsWithinTheSameDay",
            "label": "Accounts that have more then 2 exports within the same day",
            "value": 9
        },
        "AccountsThatHaveZeroFollowUpSequencesInstalledAfterBeingActiveForMoreThen30Days": {
            "key": "AccountsThatHaveZeroFollowUpSequencesInstalledAfterBeingActiveForMoreThen30Days",
            "label": "Accounts that have zero Follow Up Sequences installed after being active for more then 30 days",
            "value": 10
        }
    },
    "SellerMotivationEnum": {
        "Unknown": {
            "key": "Unknown",
            "label": "Unknown",
            "value": 1
        },
        "BadRental": {
            "key": "BadRental",
            "label": "Bad Rental",
            "value": 2
        },
        "Downsizing": {
            "key": "Downsizing",
            "label": "Downsizing",
            "value": 3
        },
        "Foreclosure": {
            "key": "Foreclosure",
            "label": "Foreclosure",
            "value": 4
        },
        "HealthIssues": {
            "key": "HealthIssues",
            "label": "Health Issues",
            "value": 5
        },
        "Inherited": {
            "key": "Inherited",
            "label": "Inherited",
            "value": 6
        },
        "ListedButNotSelling": {
            "key": "ListedButNotSelling",
            "label": "Listed but not Selling",
            "value": 7
        },
        "NeedToSellFast": {
            "key": "NeedToSellFast",
            "label": "Need to Sell Fast",
            "value": 8
        },
        "Relocating": {
            "key": "Relocating",
            "label": "Relocating",
            "value": 9
        },
        "TooManyRepairs": {
            "key": "TooManyRepairs",
            "label": "Too Many Repairs",
            "value": 10
        }
    },
    "SellingInfoTypeEnum": {
        "FixAndFlip": {
            "key": "FixAndFlip",
            "label": "Fix and Flip",
            "value": "App\\Models\\FixAndFlipSellingInfo"
        },
        "Wholesale": {
            "key": "Wholesale",
            "label": "Wholesale",
            "value": "App\\Models\\WholesaleSellingInfo"
        }
    },
    "SnippetTypeEnum": {
        "Note": {
            "key": "Note",
            "label": "Note",
            "value": 1
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 2
        },
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 3
        }
    },
    "SortByRecordsInFollowUpEnum": {
        "NextFollowUp": {
            "key": "NextFollowUp",
            "label": "Next Follow Up",
            "value": "next_follow_up"
        },
        "LastContacted": {
            "key": "LastContacted",
            "label": "Last Contacted",
            "value": "last_contacted"
        }
    },
    "StatTypeEnum": {
        "Money": {
            "key": "Money",
            "label": "Money",
            "value": "money"
        },
        "Integer": {
            "key": "Integer",
            "label": "Integer",
            "value": "integer"
        },
        "Percentage": {
            "key": "Percentage",
            "label": "Percentage",
            "value": "percentage"
        }
    },
    "StatusStateEnum": {
        "Contacting": {
            "key": "Contacting",
            "label": "Contact Not Made",
            "value": 1
        },
        "Active": {
            "key": "Active",
            "label": "Active",
            "value": 2
        },
        "FollowUp": {
            "key": "FollowUp",
            "label": "Follow Up",
            "value": 3
        },
        "Completed": {
            "key": "Completed",
            "label": "Completed",
            "value": 4
        },
        "Dead": {
            "key": "Dead",
            "label": "Dead",
            "value": 5
        },
        "NonLead": {
            "key": "NonLead",
            "label": "Non Lead",
            "value": 6
        }
    },
    "StatusTypeEnum": {
        "Standard": {
            "key": "Standard",
            "label": "Standard",
            "value": 1
        },
        "New": {
            "key": "New",
            "label": "New",
            "value": 2
        }
    },
    "StorageDiskEnum": {
        "Spaces": {
            "key": "Spaces",
            "label": "Spaces",
            "value": "spaces"
        },
        "PublicS3": {
            "key": "PublicS3",
            "label": "Public S3",
            "value": "PublicS3"
        },
        "PrivateS3": {
            "key": "PrivateS3",
            "label": "Private S3",
            "value": "PrivateS3"
        }
    },
    "StripeMetaDataEnum": {
        "UserLimit": {
            "key": "UserLimit",
            "label": "UserLimit",
            "value": "user_limit"
        },
        "RecordLimit": {
            "key": "RecordLimit",
            "label": "RecordLimit",
            "value": "record_limit"
        },
        "StorageIntegration": {
            "key": "StorageIntegration",
            "label": "StorageIntegration",
            "value": "has_storage_integration_feature"
        },
        "EmailIntegration": {
            "key": "EmailIntegration",
            "label": "EmailIntegration",
            "value": "has_email_integration_feature"
        },
        "CalendarIntegration": {
            "key": "CalendarIntegration",
            "label": "CalendarIntegration",
            "value": "has_calendar_integration_feature"
        },
        "PhoneIntegration": {
            "key": "PhoneIntegration",
            "label": "PhoneIntegration",
            "value": "has_phone_integration_feature"
        },
        "FollowUpSequence": {
            "key": "FollowUpSequence",
            "label": "FollowUpSequence",
            "value": "has_follow_up_sequence_feature"
        },
        "Webhooks": {
            "key": "Webhooks",
            "label": "Webhooks",
            "value": "has_webhooks_feature"
        },
        "Imports": {
            "key": "Imports",
            "label": "Imports",
            "value": "has_imports_feature"
        },
        "Exports": {
            "key": "Exports",
            "label": "Exports",
            "value": "has_exports_feature"
        },
        "EmailNotifications": {
            "key": "EmailNotifications",
            "label": "EmailNotifications",
            "value": "has_email_notifications_feature"
        },
        "TextNotifications": {
            "key": "TextNotifications",
            "label": "TextNotifications",
            "value": "has_text_notifications_feature"
        },
        "InviteUsers": {
            "key": "InviteUsers",
            "label": "InviteUsers",
            "value": "has_invite_users_feature"
        },
        "Automation": {
            "key": "Automation",
            "label": "Automation",
            "value": "has_automation_feature"
        },
        "CreatesPublicAssets": {
            "key": "CreatesPublicAssets",
            "label": "CreatesPublicAssets",
            "value": "has_creates_public_assets_feature"
        },
        "AdvancedReporting": {
            "key": "AdvancedReporting",
            "label": "AdvancedReporting",
            "value": "has_advanced_reporting_feature"
        },
        "SmrtPhoneIntegration": {
            "key": "SmrtPhoneIntegration",
            "label": "SmrtPhoneIntegration",
            "value": "has_smrt_phone_integration_feature"
        },
        "MidTierPropertyData": {
            "key": "MidTierPropertyData",
            "label": "MidTierPropertyData",
            "value": "has_mid_tier_property_data_feature"
        },
        "AdvancedTierPropertyData": {
            "key": "AdvancedTierPropertyData",
            "label": "AdvancedTierPropertyData",
            "value": "has_advanced_tier_property_data_feature"
        },
        "Comp": {
            "key": "Comp",
            "label": "Comp",
            "value": "has_comp_feature"
        },
        "PhoneSupport": {
            "key": "PhoneSupport",
            "label": "PhoneSupport",
            "value": "has_phone_support_feature"
        }
    },
    "SupportServicesTypeEnum": {
        "Generic": {
            "key": "Generic",
            "label": "Generic",
            "value": 0
        },
        "WhiteGlove": {
            "key": "WhiteGlove",
            "label": "WhiteGlove",
            "value": 1
        }
    },
    "TableConfigurationLocationEnum": {
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": 1
        },
        "Record": {
            "key": "Record",
            "label": "Record",
            "value": 2
        },
        "Inbox": {
            "key": "Inbox",
            "label": "Inbox",
            "value": 3
        }
    },
    "TaggableTypeEnum": {
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": 1
        },
        "Task": {
            "key": "Task",
            "label": "Task",
            "value": 2
        }
    },
    "TaskStatusEnum": {
        "Incomplete": {
            "key": "Incomplete",
            "label": "Incomplete",
            "value": 1
        },
        "Ignored": {
            "key": "Ignored",
            "label": "Ignored",
            "value": 2
        },
        "Complete": {
            "key": "Complete",
            "label": "Complete",
            "value": 3
        }
    },
    "TemperatureEnum": {
        "None": {
            "key": "None",
            "label": "None",
            "value": 0
        },
        "Cold": {
            "key": "Cold",
            "label": "Cold",
            "value": 1
        },
        "Warm": {
            "key": "Warm",
            "label": "Warm",
            "value": 2
        },
        "Hot": {
            "key": "Hot",
            "label": "Hot",
            "value": 3
        }
    },
    "ThrottleTypeEnum": {
        "Webhook": {
            "key": "Webhook",
            "label": "Webhook",
            "value": 0
        },
        "PhoneNumber": {
            "key": "PhoneNumber",
            "label": "Phone Number",
            "value": 1
        },
        "MailgunEventWebhook": {
            "key": "MailgunEventWebhook",
            "label": "Mailgun Event Webhook",
            "value": 2
        },
        "MailgunRouteWebhook": {
            "key": "MailgunRouteWebhook",
            "label": "Mailgun Route Webhook",
            "value": 3
        }
    },
    "UnitedStatesStatesEnum": {
        "ALABAMA": {
            "key": "ALABAMA",
            "label": "ALABAMA",
            "value": "Alabama"
        },
        "ALASKA": {
            "key": "ALASKA",
            "label": "ALASKA",
            "value": "Alaska"
        },
        "ARIZONA": {
            "key": "ARIZONA",
            "label": "ARIZONA",
            "value": "Arizona"
        },
        "ARKANSAS": {
            "key": "ARKANSAS",
            "label": "ARKANSAS",
            "value": "Arkansas"
        },
        "CALIFORNIA": {
            "key": "CALIFORNIA",
            "label": "CALIFORNIA",
            "value": "California"
        },
        "COLORADO": {
            "key": "COLORADO",
            "label": "COLORADO",
            "value": "Colorado"
        },
        "CONNECTICUT": {
            "key": "CONNECTICUT",
            "label": "CONNECTICUT",
            "value": "Connecticut"
        },
        "DELAWARE": {
            "key": "DELAWARE",
            "label": "DELAWARE",
            "value": "Delaware"
        },
        "DISTRICTOFCOLUMBIA": {
            "key": "DISTRICTOFCOLUMBIA",
            "label": "DISTRICT OF COLUMBIA",
            "value": "District Of Columbia"
        },
        "FLORIDA": {
            "key": "FLORIDA",
            "label": "FLORIDA",
            "value": "Florida"
        },
        "GEORGIA": {
            "key": "GEORGIA",
            "label": "GEORGIA",
            "value": "Georgia"
        },
        "HAWAII": {
            "key": "HAWAII",
            "label": "HAWAII",
            "value": "Hawaii"
        },
        "IDAHO": {
            "key": "IDAHO",
            "label": "IDAHO",
            "value": "Idaho"
        },
        "ILLINOIS": {
            "key": "ILLINOIS",
            "label": "ILLINOIS",
            "value": "Illinois"
        },
        "INDIANA": {
            "key": "INDIANA",
            "label": "INDIANA",
            "value": "Indiana"
        },
        "IOWA": {
            "key": "IOWA",
            "label": "IOWA",
            "value": "Iowa"
        },
        "KANSAS": {
            "key": "KANSAS",
            "label": "KANSAS",
            "value": "Kansas"
        },
        "KENTUCKY": {
            "key": "KENTUCKY",
            "label": "KENTUCKY",
            "value": "Kentucky"
        },
        "LOUISIANA": {
            "key": "LOUISIANA",
            "label": "LOUISIANA",
            "value": "Louisiana"
        },
        "MAINE": {
            "key": "MAINE",
            "label": "MAINE",
            "value": "Maine"
        },
        "MARYLAND": {
            "key": "MARYLAND",
            "label": "MARYLAND",
            "value": "Maryland"
        },
        "MASSACHUSETTS": {
            "key": "MASSACHUSETTS",
            "label": "MASSACHUSETTS",
            "value": "Massachusetts"
        },
        "MICHIGAN": {
            "key": "MICHIGAN",
            "label": "MICHIGAN",
            "value": "Michigan"
        },
        "MINNESOTA": {
            "key": "MINNESOTA",
            "label": "MINNESOTA",
            "value": "Minnesota"
        },
        "MISSISSIPPI": {
            "key": "MISSISSIPPI",
            "label": "MISSISSIPPI",
            "value": "Mississippi"
        },
        "MISSOURI": {
            "key": "MISSOURI",
            "label": "MISSOURI",
            "value": "Missouri"
        },
        "MONTANA": {
            "key": "MONTANA",
            "label": "MONTANA",
            "value": "Montana"
        },
        "NEBRASKA": {
            "key": "NEBRASKA",
            "label": "NEBRASKA",
            "value": "Nebraska"
        },
        "NEVADA": {
            "key": "NEVADA",
            "label": "NEVADA",
            "value": "Nevada"
        },
        "NEWHAMPSHIRE": {
            "key": "NEWHAMPSHIRE",
            "label": "NEW HAMPSHIRE",
            "value": "New Hampshire"
        },
        "NEWJERSEY": {
            "key": "NEWJERSEY",
            "label": "NEW JERSEY",
            "value": "New Jersey"
        },
        "NEWMEXICO": {
            "key": "NEWMEXICO",
            "label": "NEW MEXICO",
            "value": "New Mexico"
        },
        "NEWYORK": {
            "key": "NEWYORK",
            "label": "NEW YORK",
            "value": "New York"
        },
        "NORTHCAROLINA": {
            "key": "NORTHCAROLINA",
            "label": "NORTH CAROLINA",
            "value": "North Carolina"
        },
        "NORTHDAKOTA": {
            "key": "NORTHDAKOTA",
            "label": "NORTH DAKOTA",
            "value": "North Dakota"
        },
        "OHIO": {
            "key": "OHIO",
            "label": "OHIO",
            "value": "Ohio"
        },
        "OKLAHOMA": {
            "key": "OKLAHOMA",
            "label": "OKLAHOMA",
            "value": "Oklahoma"
        },
        "OREGON": {
            "key": "OREGON",
            "label": "OREGON",
            "value": "Oregon"
        },
        "PENNSYLVANIA": {
            "key": "PENNSYLVANIA",
            "label": "PENNSYLVANIA",
            "value": "Pennsylvania"
        },
        "RHODEISLAND": {
            "key": "RHODEISLAND",
            "label": "RHODE ISLAND",
            "value": "Rhode Island"
        },
        "SOUTHCAROLINA": {
            "key": "SOUTHCAROLINA",
            "label": "SOUTH CAROLINA",
            "value": "South Carolina"
        },
        "SOUTHDAKOTA": {
            "key": "SOUTHDAKOTA",
            "label": "SOUTH DAKOTA",
            "value": "South Dakota"
        },
        "TENNESSEE": {
            "key": "TENNESSEE",
            "label": "TENNESSEE",
            "value": "Tennessee"
        },
        "TEXAS": {
            "key": "TEXAS",
            "label": "TEXAS",
            "value": "Texas"
        },
        "UTAH": {
            "key": "UTAH",
            "label": "UTAH",
            "value": "Utah"
        },
        "VERMONT": {
            "key": "VERMONT",
            "label": "VERMONT",
            "value": "Vermont"
        },
        "VIRGINIA": {
            "key": "VIRGINIA",
            "label": "VIRGINIA",
            "value": "Virginia"
        },
        "WASHINGTON": {
            "key": "WASHINGTON",
            "label": "WASHINGTON",
            "value": "Washington"
        },
        "WESTVIRGINIA": {
            "key": "WESTVIRGINIA",
            "label": "WEST VIRGINIA",
            "value": "West Virginia"
        },
        "WISCONSIN": {
            "key": "WISCONSIN",
            "label": "WISCONSIN",
            "value": "Wisconsin"
        },
        "WYOMING": {
            "key": "WYOMING",
            "label": "WYOMING",
            "value": "Wyoming"
        }
    },
    "UserDefinedFollowUpSequenceStepTypeEnum": {
        "Text": {
            "key": "Text",
            "label": "Text",
            "value": 1
        },
        "Email": {
            "key": "Email",
            "label": "Email",
            "value": 2
        },
        "Task": {
            "key": "Task",
            "label": "Task",
            "value": 3
        }
    },
    "UserRoleEnum": {
        "LeadManager": {
            "key": "LeadManager",
            "label": "Lead Manager",
            "value": 1
        },
        "AcquisitionsManager": {
            "key": "AcquisitionsManager",
            "label": "Acquisitions Manager",
            "value": 2
        },
        "DispositionsManager": {
            "key": "DispositionsManager",
            "label": "Dispositions Manager",
            "value": 3
        },
        "RehabManager": {
            "key": "RehabManager",
            "label": "Rehab Manager",
            "value": 4
        },
        "TransactionCoordinator": {
            "key": "TransactionCoordinator",
            "label": "Transaction Coordinator",
            "value": 5
        }
    },
    "UserTypeEnum": {
        "Account": {
            "key": "Account",
            "label": "Account",
            "value": 0
        },
        "Partner": {
            "key": "Partner",
            "label": "Partner",
            "value": 1
        }
    },
    "WebhookDataTypeEnum": {
        "Lead": {
            "key": "Lead",
            "label": "Lead",
            "value": 1
        },
        "Contact": {
            "key": "Contact",
            "label": "Contact",
            "value": 2
        }
    },
    "WebhookLogQueueableTypeEnum": {
        "ProcessOutboundSmrtPhoneSmsMessage": {
            "key": "ProcessOutboundSmrtPhoneSmsMessage",
            "label": "Process Outbound SmrtPhone Sms Message",
            "value": 1
        }
    },
    "WebhookLogStatusEnum": {
        "Received": {
            "key": "Received",
            "label": "Received",
            "value": 0
        },
        "Processed": {
            "key": "Processed",
            "label": "Processed",
            "value": 1
        },
        "Abandoned": {
            "key": "Abandoned",
            "label": "Abandoned",
            "value": 2
        }
    },
    "WebhookLogTypeEnum": {
        "CallRail": {
            "key": "CallRail",
            "label": "CallRail",
            "value": 0
        },
        "MailGun": {
            "key": "MailGun",
            "label": "MailGun",
            "value": 1
        },
        "SignalWire": {
            "key": "SignalWire",
            "label": "SignalWire",
            "value": 2
        },
        "Twilio": {
            "key": "Twilio",
            "label": "Twilio",
            "value": 3
        },
        "CallScript": {
            "key": "CallScript",
            "label": "CallScript",
            "value": 4
        },
        "SmrtPhone": {
            "key": "SmrtPhone",
            "label": "SmrtPhone",
            "value": 5
        }
    },
    "WebhookTypeEnum": {
        "Default": {
            "key": "Default",
            "label": "Default",
            "value": 1
        },
        "LaunchControl": {
            "key": "LaunchControl",
            "label": "Launch Control",
            "value": 2
        }
    },
    "WholesaleSellingInfoStatusEnum": {
        "MarketingProperty": {
            "key": "MarketingProperty",
            "label": "Marketing Property",
            "value": 1
        },
        "DueDiligence": {
            "key": "DueDiligence",
            "label": "Due Diligence",
            "value": 2
        },
        "TitleIssues": {
            "key": "TitleIssues",
            "label": "Title Issues",
            "value": 3
        },
        "AcceptedOffer": {
            "key": "AcceptedOffer",
            "label": "Accepted Offer",
            "value": 4
        },
        "Assigned": {
            "key": "Assigned",
            "label": "Assigned",
            "value": 5
        },
        "Closed": {
            "key": "Closed",
            "label": "Closed",
            "value": 6
        }
    }
}